<main-footer>
  <div id="footer-units">
    <h4>Unidades</h4>
    <template each={ unit in physicalUnits }>
      <div class='unit-container'>
        <span class="title">{ unit.city }</span>
        <p>{ unit.adresses }</p>
      </div>
    </template>
  </div>

  <!-- <div id="footer-xp-sac">
    <h4>Ouvidoria XP</h4>
    <div>
      <span class="title">TELEFONE: 0800 722 - 3710</span>
      <p>
        (Dias úteis das 9h às 18h)
      </p>
    </div>
  </div> -->

  <!--  <div id="terms">
    <a href="#/politicas-de-privacidade">Políticas de Privacidade</a>
  </div>  -->

  <div id="terms">
    <a href="#/politicas-de-privacidade">Políticas de Privacidade</a>
  </div>

  <div id="copyrights">
    VLGI CORPORATE © 2021<br>
    TODOS OS DIREITOS RESERVADOS
  </div>

  <script>
    import './main-footer.scss'
    import {locations} from './locations'

    export default {
      physicalUnits: locations.filter(each => each.adresses != '' && each),
      onMounted() {
        this.breakLines()
      },
      breakLines(){
        this.$$('.unit-container p').forEach(x => {
          x.innerHTML = x.innerText
        })
      }
    }
  </script>
</main-footer>
